import {LocaleKey} from "./Locale";

export const LocaleEN: LocaleKey = {
    trailerVittaLucis: 'https://www.youtube.com/watch?v=zXBo0ZHEWNc',
    trailerIkeNorris: 'https://www.youtube.com/watch?v=6vR1--XnnF8',
    about: 'I love video games very much, I talk about my projects, share my experience and the development process.',
    soundtrack: 'Soundtrack',
    pressKit: 'Press Kit',
    gameVittaLucis: 'Vitta Lucis is a mercenary from a private church guild, possessing demonic powers. Assemble a squad of Church Demons and embark on a dark fantasy action adventure. Faith in God was partly a mistake - curses, demons, and other evil spirits do exist.',
    gameIkeNorris: 'Ike Norris is a good boy and a very friendly dog, and also a member of my family! As you can guess, the plot of the game will be connected with him. I will not reveal all the cards, my game will tell about it. The prologue is now available!',
    socialNetworksTitle: 'Social Networks',
    socialNetworksDescription: 'All the latest news',
    contactsTitle: 'Contacts',
    contactsDescription: 'Sergey Isaev',
    yandexMail: 'Yandex Mail',
    otherTitle: 'Other',
    otherDescription: 'Official pages on the Internet',
    yandexMusic: 'Yandex Music',
    vkMusic: 'VK Music',
    zvuk: 'Zvuk',
    mtsMusic: 'MTS Music',
    supportTitle: 'Support',
    supportDescription: 'Video game development',
    yandexTips: 'Yandex Tips',
    inactiveTitle: 'Inactive',
    inactiveDescription: 'Also official pages',
    dzen: 'Dzen',
    platform: 'Platform',
    trashTitle: 'Trash',
    trashDescription: 'The site has either shadowbanned, completely blocked, or no longer exists.',
    pikabu: 'Pikabu'
}
